import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14ec638e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "detailNotification",
  tabindex: "1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "p-3 modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  })
], -1))
const _hoisted_5 = { class: "d-flex justify-content-center mb-3" }
const _hoisted_6 = { class: "text-center fw-bold" }
const _hoisted_7 = { class: "p-lg-5 p-2" }
const _hoisted_8 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_9 = { class: "d-flex align-items-center mb-3" }
const _hoisted_10 = {
  key: 0,
  class: "ms-2 fs-7 fw-bold text-lobby"
}
const _hoisted_11 = {
  key: 1,
  class: "ms-1 fs-7 fw-bold text-community"
}
const _hoisted_12 = { class: "fs-8 date" }
const _hoisted_13 = { class: "fw-bold mb-lg-4 mb-3 border-bottom pb-4" }
const _hoisted_14 = { class: "d-flex justify-content-center action-bottom-groups" }
const _hoisted_15 = ["href"]

import { translate } from '@/languages/i18n'
import { computed, ComputedRef, ref } from 'vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import dayjs from 'dayjs'
import { ACCOUNT_STORE, AUTH_STORE } from '@/store/constants'
import { useStore } from 'vuex'
import Button from '@/components/button/index.vue'
import TargetTag from '@/components/target-tag/index.vue'
import { slideUnicodeWithMentionMarkCheck } from '@/utils'
import DOMPurify from 'dompurify'
import { textMentionSanitizeConfig } from '@/constants/validate'
import { getUnicodeLength, sliceUnicode } from '@/utils'
//TODO: SR30

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const data = computed(() => store.getters[AUTH_STORE.GETTERS.GET_DETAIL_NOTIFICATIONS])
const listUser = computed<ComputedRef>(() => store.getters[ACCOUNT_STORE.GETTERS.LIST_USER_WITH_DELETED])
const contentData = computed(() => {
  if (!data.value?.content_base) {
    return data.value?.content
  }

  let processedContent = ''

  // Purify content
  var purifyContent = DOMPurify.sanitize(escapeHtmlEntities(data.value?.content), textMentionSanitizeConfig)

  // Create a temporary DOM element to parse the HTML content
  var tempDiv = document.createElement('div')
  tempDiv.innerHTML = purifyContent
  // Traverse the original HTML and reconstruct up to the limit 100 characters
  var currentLength = 0
  var maxLength = 100
  var result = ''
  var reachedLimit = false

  var hasMoreContentThanLimit = false
  function traverse(node) {
    if (node.nodeType === Node.TEXT_NODE || (node.nodeType === Node.ELEMENT_NODE && node.tagName !== 'SPAN')) {
      var textContent = node.nodeType === Node.TEXT_NODE ? node.textContent : node.outerHTML
      const textContentLength = getUnicodeLength(textContent)
      // Check if adding this text node would exceed maxLength
      if (currentLength + textContentLength > maxLength) {
        // Slice the text content up to the remaining allowed length
        if (!reachedLimit) {
          if (textContent.startsWith('@') || textContent.startsWith('＠')) {
            result += slideUnicodeWithMentionMarkCheck(textContent, maxLength - currentLength)
            reachedLimit = false
          } else {
            result += sliceUnicode(textContent, maxLength - currentLength)
            reachedLimit = true
            result += '...'
          }
          hasMoreContentThanLimit = true
        }
        currentLength = maxLength
      } else {
        result += textContent
        currentLength += textContentLength
      }
    } else if (node.nodeType === Node.ELEMENT_NODE && !reachedLimit) {
      result += '<' + node.tagName.toLowerCase()
      for (var i = 0; i < node.attributes.length; i++) {
        result += ' ' + node.attributes[i].name + '="' + node.attributes[i].value + '"'
      }
      if (node.tagName === 'SPAN' && node.classList.contains('mention-highlight')) {
        result += ' contenteditable="false"'
      }
      result += '>'

      for (var j = 0; j < node.childNodes.length; j++) {
        traverse(node.childNodes[j])
        if (currentLength >= maxLength) {
          break
        }
      }

      // Append closing tag
      if (node.tagName === 'SPAN') {
        result += '</' + node.tagName.toLowerCase() + '>'
      }
      if (!reachedLimit && hasMoreContentThanLimit) {
        reachedLimit = true
        result += '...'
      }
    }
  }

  // Start traversing from the actual child nodes of tempDiv to skip the div itself
  tempDiv.childNodes.forEach((child) => traverse(child))
  processedContent = result
  return `${data.value?.content_base}\n${processedContent}`
})

const escapeHtmlEntities = (str) => {
  if (typeof str !== 'string') return str
  return str.replace(/&/g, '&amp;')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(translate)('notification')), 1)
        ]),
        _createElementVNode("article", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(UserAliasIcon, {
                userType: _unref(data)?.updated_mynavi_user_id || _unref(data)?.notifications_type ? 'yelloop' : 'community_admin'
              }, null, 8, ["userType"]),
              (_unref(data)?.updated_mynavi_user_id || _unref(data)?.notifications_type)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, "YELLoop"))
                : _createCommentVNode("", true),
              (!_unref(data)?.updated_mynavi_user_id && !_unref(data)?.notifications_type)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(translate)('SN10managementOffice')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(data)?.created_at ? _unref(dayjs)(_unref(data)?.created_at).format('YYYY/MM/DD HH:mm') : _unref(dayjs)(_unref(data)?.public_date).format('YYYY/MM/DD HH:mm')), 1)
          ]),
          _createElementVNode("h6", _hoisted_13, _toDisplayString(_unref(data)?.title), 1),
          _createVNode(TargetTag, {
            data: _unref(contentData),
            className: 'mb-4',
            users: _unref(listUser),
            contentDetail: true
          }, null, 8, ["data", "users"]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              className: 'fw-bold'
            }, null, 8, ["title"]),
            (_unref(data)?.notifications_type)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _unref(data)?.detail_link
                }, [
                  _createVNode(Button, {
                    title: _unref(translate)('confirm'),
                    type: 'secondary',
                    "data-bs-dismiss": "modal",
                    className: 'fw-bold ms-2'
                  }, null, 8, ["title"])
                ], 8, _hoisted_15))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})